<script>
export default {
	name: 'FilePreviewElement',
	props: ['item'],
	methods: {
		log() {
			console.log(this.item)
		},
		closeBtn() {
			window.$destroyFilePreview()
		},
		escListener(event) {
			if (event.keyCode === 27) {
				this.closeBtn()
			}
		}
	},
	mounted() {
		document.addEventListener('keydown', this.escListener, true)
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.escListener, true)
	}
}
</script>

<template>
	<div class="filePreviewElement" @click="log">
		<div class="imgBox" v-if="item.mime.startsWith('image')">
			<img :src="item.path.url" alt="img" style="max-height: 80vh;" />
		</div>
		<div class="videoBox" v-if="item.mime.startsWith('video')">
			<video :src="item.path.url" controls style="max-height: 80vh;" />
		</div>
		<div class="videoBox" v-if="item.mime.startsWith('audio')">
			<audio :src="item.path.url" controls style="max-height: 80vh;" />
		</div>
		<img class="closeBtn" @click="closeBtn" :src="require('@/assets/image/closeBtn.png')" alt="close button" />
	</div>
</template>

<style scoped lang="scss">
.filePreviewElement {
	width: 100vw;
	height: 100vh;
	position: fixed;
	left: 0;
	top: 0;
	z-index: 9999999;
	background-color: #b5b5b59c;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	.closeBtn {
		width: 50px;
		height: 50px;
		cursor: pointer;
		margin-top: 10px;
	}
}
</style>